import { useBoolean } from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { BsMessenger } from 'react-icons/bs';
import { Button } from '../../../components/button/Button';
import { FeatureContext } from '../../../Context';
import { lang } from '../../../Utils';
import { createComment } from '../Services';

const CreateComment = () => {

  const context = useContext(FeatureContext);
  const [comment, setComment] = useState('');
  const [numCharacter, setNumCharacter] = useState(0);
  const [loader, setLoader] = useBoolean();

  const handleChange = (event) => {
    if (event.target.value.length <= 500) {
      setNumCharacter(event.target.value.length);
      setComment(event.target.value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoader.on()
    createComment({ comment: comment, enquiryId: context?.details?.enquiryId })
      .then(data => {
        setComment('');
        setNumCharacter(0);
        context.setComments(data?.data?.comments);
      })
      .finally(_ => setLoader.off());
  }

  return (<>
    <div className="bf-enquiry-comment-form">
      <div>
        <small>{numCharacter} / 500</small>
        <Button disabled={numCharacter <= 0} onClick={handleSubmit} variant="default">
          <BsMessenger /><span>{lang('Send')}</span>
        </Button>
      </div>
      <textarea onChange={handleChange} value={comment}></textarea>

      {(loader) ?
        <div className="bf-enquiry-comment-submit">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="20" viewBox="0 0 80 35" fill="#000">
            <circle cx="10" cy="10" r="10">
              <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="10;5;10" calcMode="linear" repeatCount="indefinite" />
              <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="35" cy="10" r="5" fillOpacity="0.3">
              <animate attributeName="r" from="5" to="5" begin="0s" dur="0.8s" values="5;10;5" calcMode="linear" repeatCount="indefinite" />
              <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="60" cy="10" r="10">
              <animate attributeName="r" from="10" to="10" begin="0s" dur="0.8s" values="10;5;10" calcMode="linear" repeatCount="indefinite" />
              <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
          </svg>
        </div>
        : null
      }
    </div>
  </>)
}

export default CreateComment;